import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import { useAuth } from '@/contexts/AuthContext';
import UserAvatar from './UserAvatar';
const ProfileHeader: React.FC = () => {
  const {
    resolvedTheme
  } = useTheme();
  const {
    user
  } = useAuth();

  // Get username from user data, fallback to full name or email
  const username = user?.user_metadata?.username || user?.user_metadata?.full_name || user?.user_metadata?.name || (user?.email ? user.email.split('@')[0] : 'Your Account');

  // Get avatar URL from user metadata if available
  const avatarUrl = user?.user_metadata?.avatar_url || undefined;
  return null;
};
export default ProfileHeader;